export default {
  confirmDelete: {
    header: 'Delete parameter "{parameter}" of "{asset}"?',
    message: 'The value of the next higher-level asset applies instead, or the default value if no asset defines one.',
  },
};
